/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config: { [key: string]: string } = {};
config.production = process.env.PRODUCTION || "false",
config.sitecoreApiHost = process.env.SITECORE_API_HOST || "https://sc103.arubabank.local",
config.sitecoreApiKey = process.env.SITECORE_API_KEY || "{2A4DCA72-3283-4714-B8C9-D175B84CF9F4}",
config.jssAppName = process.env.JSS_APP_NAME || "personal",
config.sitecoreLayoutServiceConfig = process.env.SITECORE_LAYOUT_SERVICE_CONFIG || "jss",
config.defaultLanguage = process.env.DEFAULT_LANGUAGE || "en",
config.defaultServerRoute = process.env.DEFAULT_SERVER_ROUTE || "/",
config.graphQLEndpointPath = process.env.GRAPH_QL_ENDPOINT_PATH || "/api/personal",
config.graphQLEndpoint = process.env.GRAPH_QL_ENDPOINT || `${config.sitecoreApiHost}${config.graphQLEndpointPath}`;
export const environment = config;